import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "className"];
import React, { useEffect } from 'react';
import classNames from 'classnames';
import copy from 'copy-to-clipboard';
import mergeRefs from './utils/mergeRefs';
import { iconPath as copyPath, svgTpl } from './icons/Copy';
import { iconPath as checkPath } from './icons/Check';
import { jsx as _jsx } from "react/jsx-runtime";
function appendCopyButton(container) {
  if (!container) {
    return;
  }
  var button = document.createElement('button');
  button.className = 'copy-code-button rs-btn-icon rs-btn-icon-circle rs-btn rs-btn-subtle rs-btn-xs';
  button.title = 'Copy code';
  button.innerHTML = svgTpl(copyPath);
  button.onclick = function (e) {
    var _container$querySelec;
    e.preventDefault();
    var code = container === null || container === void 0 ? void 0 : (_container$querySelec = container.querySelector('code')) === null || _container$querySelec === void 0 ? void 0 : _container$querySelec.textContent;
    var icon = button.querySelector('.copy-icon-path');
    icon === null || icon === void 0 ? void 0 : icon.setAttribute('d', checkPath);
    if (code) {
      copy(code);
    }
    setTimeout(function () {
      icon === null || icon === void 0 ? void 0 : icon.setAttribute('d', copyPath);
    }, 2000);
  };
  container === null || container === void 0 ? void 0 : container.appendChild(button);
}
var MarkdownRenderer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var mdRef = React.useRef(null);
  useEffect(function () {
    var _mdRef$current;
    (_mdRef$current = mdRef.current) === null || _mdRef$current === void 0 ? void 0 : _mdRef$current.querySelectorAll('.rcv-code-renderer').forEach(function (el) {
      appendCopyButton(el);
    });
  }, []);
  if (!children) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", _extends({}, rest, {
    ref: mergeRefs(mdRef, ref),
    className: classNames(className, 'rcv-markdown'),
    dangerouslySetInnerHTML: {
      __html: children
    }
  }));
});
export default MarkdownRenderer;